export class ListZeroEtlPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "zeroEtlPolicies",
            "baseName": "zeroEtlPolicies",
            "type": "Array<ZeroEtlPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
